import { Ptag } from "components/core";
import React from "react";
import styled from "styled-components";
import { colors } from "theme";

function TextInline({ name, label, height }) {
  console.log(height);
  return (
    <div>
      {label && (
        <Ptag fontWeight="500" fontSize="16px" marginBottom="1rem">
          {label}
        </Ptag>
      )}
      <TpaName height={height ? height : "64px"}>
        <Ptag fontWeight="500" fontSize="16px">
          {name}
        </Ptag>
      </TpaName>
    </div>
  );
}

export default TextInline;

const TpaName = styled.div`
  height: ${(props) => (props.height ? props.height : "64px")};
  background-color: #fdefcc;
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding-left: 20px;
`;
